<span *ngIf="style == null"><span *ngIf="_variation > 0">+</span>{{_variation | formatnumber: 2}}%</span>
<div *ngIf="style == 1" class="stock-rate" [ngClass]="{'red': _variation < 0}"><span *ngIf="_variation > 0">+</span>{{_variation | formatnumber: 2}}%</div>
<div *ngIf="style == 2" class="div-block-90 w-clearfix flex justify-end items-center">
  <img *ngIf="_variation > 0" src="/assets/images/Polygon-1.svg" loading="lazy" class="image-29">
  <img *ngIf="_variation < 0" src="/assets/images/Polygon-2a.svg" loading="lazy" class="image-29">
  <div [ngClass]="{'red': _variation < 0}" class="numbers">{{_variation | formatnumber: 2}}%</div>
</div>
